import React, {useEffect, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import MDSpinner from "react-md-spinner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImage, faFileAlt} from "@fortawesome/free-solid-svg-icons";
import "./DownloadPdfModal.scss";

const formatBytes = bytes => {
    if (!bytes) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    const idx = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    return `${(bytes / Math.pow(1024, idx)).toFixed(1)} ${units[idx]}`;
};

const DownloadPdfModal = ({token, printView, fetchPdfBlobs, onClose, onDownload}) => {
    const [option, setOption] = useState('with-pictures');
    const [blobs, setBlobs] = useState(null);

    useEffect(() => {
        if (token) {
            fetchPdfBlobs(token, printView, setBlobs);
        }
    }, []);

    const renderCard = (value, icon, label, color, blob) => (
        <div
            className={`download-radio-card ${option === value ? 'active' : ''}`}
            onClick={() => setOption(value)}
        >
            <div className="radio-left">
                <input
                    type="radio"
                    name="downloadOption"
                    checked={option === value}
                    readOnly
                />
                <div className="icon-box">
                    <FontAwesomeIcon icon={icon}/>
                </div>
                <span className="option-name">{label}</span>
            </div>
            <div className="radio-right">
                <span className={`estimate-label ${color}`}>File Size</span>
                <span className="estimate-size">
                    {blob ? formatBytes(blob.size) : <MDSpinner size={20}/>}
                </span>
            </div>
        </div>
    );

    return (
        <div className="static-modal">
            <Modal
                id="download-modal"
                bsSize="medium"
                style={{zIndex: 99999}}
                animation={false}
                show
                onHide={onClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Download PDF</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderCard('with-pictures', faImage, 'Include Asset Pictures', 'text-green', blobs?.withImages)}
                    {renderCard('without-pictures', faFileAlt, 'Do Not Include Pictures', 'text-dark', blobs?.withoutImages)}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="cancel-modal-button"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        bsStyle="primary"
                        className="download-modal-button"
                        disabled={!blobs}
                        onClick={() => {
                            const withImages = option === 'with-pictures';
                            onDownload(withImages, withImages ? blobs.withImages : blobs.withoutImages);
                        }}
                    >
                        Download PDF
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DownloadPdfModal;
